import { FC, PropsWithChildren } from 'react';
import { Text } from '@bridebook/aura';

interface IProps extends PropsWithChildren {}

export const RsvpText: FC<IProps> = ({ children }) => <Text variant="typo-sm">{children}</Text>;
